var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagicStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7318 4.48488L18.6559 8.59072C18.6451 9.15405 19.0026 9.90155 19.4576 10.2374L22.1443 12.2741C23.8668 13.5741 23.5851 15.1666 21.5268 15.8166L18.0276 16.9107C17.4426 17.0949 16.8251 17.7341 16.6734 18.3299L15.8393 21.5149C15.1784 24.0282 13.5318 24.2774 12.1668 22.0674L10.2601 18.9799C9.91344 18.4166 9.09011 17.9941 8.44011 18.0265L4.82178 18.2107C2.23261 18.3407 1.49594 16.8457 3.18594 14.8741L5.33094 12.3824C5.73178 11.9166 5.91594 11.0499 5.73178 10.4649L4.62678 6.95488C3.98761 4.89655 5.13594 3.75905 7.18344 4.43072L10.3793 5.48155C10.9209 5.65488 11.7334 5.53572 12.1884 5.19988L15.5251 2.79488C17.3343 1.50572 18.7751 2.26405 18.7318 4.48488Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2251 22.1758L19.9426 18.8933C19.6284 18.5792 19.1084 18.5792 18.7942 18.8933C18.4801 19.2075 18.4801 19.7275 18.7942 20.0417L22.0767 23.3242C22.2392 23.4867 22.4451 23.5625 22.6509 23.5625C22.8567 23.5625 23.0626 23.4867 23.2251 23.3242C23.5392 23.01 23.5392 22.49 23.2251 22.1758Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicStar);
export default __webpack_public_path__ + "static/media/magic-star.e0beca42cfef90523fdfd8ec5e3de49d.svg";
export { ForwardRef as ReactComponent };